const navbarCollapse = document.getElementById('navbarCollapse')
const navbar = document.getElementById('navbar')

let prevScrollpos = window.pageYOffset

window.onscroll = function () {
  const currentScrollPos = window.pageYOffset
  if (prevScrollpos > currentScrollPos || prevScrollpos === 0) {
    navbar.classList.remove('navbar--hidden')
  } else {
    if (!navbarCollapse.classList.contains('show')) {
      navbar.classList.add('navbar--hidden')
    }
  }
  prevScrollpos = currentScrollPos > 0 ? currentScrollPos : 0
}
